import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { formatViews, formatDate } from '@/utils/format';

export default function LatestUpdates() {
  const latest = articles
    .filter((a) => a.category === 'latest' || a.category === 'popular')
    .slice(0, 6);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">第一时间掌握蜜桃传媒最新内容动态</p>
          </div>
          <Link
            to="/category/latest"
            className="whitespace-nowrap text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latest.map((article) => (
            <article key={article.id} className="group flex gap-4 p-4 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer" data-product-shop>
              <Link to={`/article/${article.id}`} className="flex gap-4 w-full">
                <div className="w-28 h-20 flex-shrink-0 rounded-md overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={`${article.title} - 蜜桃传媒最新内容`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1.5 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-1 mb-2">{article.excerpt}</p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span>{formatDate(article.date)}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {formatViews(article.views)}
                    </span>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}